import { render, staticRenderFns } from "./StoryRelated.vue?vue&type=template&id=88034970&scoped=true&"
import script from "./StoryRelated.vue?vue&type=script&lang=js&"
export * from "./StoryRelated.vue?vue&type=script&lang=js&"
import style0 from "./StoryRelated.vue?vue&type=style&index=0&id=88034970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88034970",
  null
  
)

export default component.exports